import { Component, OnInit } from '@angular/core';
import { OutingApprovalApiService } from '../outing-approval-api.service';
import { GridOptions } from 'ag-grid-community';
import { Html5Qrcode } from 'html5-qrcode';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-gatepass-outing',
  templateUrl: './gatepass-outing.component.html',
  styleUrls: ['./gatepass-outing.component.scss']
})
export class GatepassOutingComponent implements OnInit {
  gatepasslist: any;
 showScanner = false;
  qrScanner!: Html5Qrcode;
  gridColumnApi: any
  pageSize = 10;
  searchText = '';
  gridApi: any;
  rowData: any[] = [];
  defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1
  };
  constructor(private data:OutingApprovalApiService,private cdr: ChangeDetectorRef) {

  }
  columnDefs = [
    {
      headerName: 'Request Id',
      field: 'requestId',
      width: 140
    },
    {
      headerName: 'Request Type',
      field: 'requestType',
      width: 140,
      cellStyle: (p: any) => {
        if (p.value === 'SINGLE') return { color: '#ff7a00', fontWeight: '600' };
        if (p.value === 'BULK') return { color: '#7b3fe4', fontWeight: '600' };
        return { color: '#008cff', fontWeight: '600' };
      }
    },
    {
      headerName: 'Apply Date',
      field: 'applyDate',
      width: 160
    },
    {
      headerName: 'Outing Reason',
      field: 'outingReason',
      width: 160
    },
    {
      headerName: 'Outing Time',
      field: 'outingTime',
      width: 260
    },
    {
      headerName: 'In Time',
      field: 'inTime',
      width: 260
    },
    {
      headerName: 'Request Status',
      field: 'requestStatus',
      width: 150,
      cellStyle: (p: any) => {
        if (p.value === 'APPROVED') {
          return { color: '#198754', fontWeight: '600' }; // Green
        }
        if (p.value === 'REJECTED') {
          return { color: '#dc3545', fontWeight: '600' }; // Red
        }
        if (p.value === 'PENDING') {
          return { color: '#ff7a00', fontWeight: '600' }; // Orange
        }
        return { color: '#444', fontWeight: '600' };
      }
    },
    {
      headerName: 'Outing Allowed',
      field: 'outingAllowed',
      width: 150,
      cellStyle: (p: any) => {
        const value = p.value && p.value.trim() !== '' ? 'Done' : 'Pending';

        if (value === 'Done') {
          return { color: '#0d6efd', fontWeight: '600' }; // Blue
        }
        return { color: '#ff7a00', fontWeight: '600' }; // Orange (Pending)
      },
      valueFormatter: (p: any) =>
        p.value && p.value.trim() !== '' ? 'Done' : 'Pending'
    }, {
      headerName: 'Action',
      width: 100,
      cellStyle: {
        cursor: 'pointer'   
      },
      cellRenderer: () =>
        `<i class="bi bi-eye action-eye"></i>`
    }
  ];

  ngOnInit(): void {
    this.loaddata()
  }
  loaddata() {
    this.data.getgatepass().subscribe(res => {
      this.gatepasslist = res || [];
      this.rowData = this.gatepasslist;
    })
  }
  // onGridReady(params: any) {
  //   this.gridApi = params.api;
  //   this.gridColumnApi = params.columnApi;
  // }
  gridOptions: GridOptions = {
    animateRows: true,
    pagination: true,
  };


  onPageSizeChanged() {
    this.gridApi.paginationSetPageSize(Number(this.pageSize));
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
  }
  onQuickFilterChanged() {
    this.gridApi.setQuickFilterText(this.searchText);
  }
openScanner() {
  if (this.showScanner) return;

  this.showScanner = true;

  setTimeout(() => {
    this.qrScanner = new Html5Qrcode('qr-reader');

    this.qrScanner.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: 250 },
      (decodedText) => {
        this.searchText = decodedText;
        this.closeScanner(); // auto close
      },
      () => {}
    );
  });
}
closeScanner() {
  this.showScanner = false;
  this.cdr.detectChanges(); // 🔑 force UI update

  if (this.qrScanner) {
    this.qrScanner.stop()
      .then(() => {
        this.qrScanner.clear();
        this.qrScanner = undefined as any; // 🔥 destroy instance
      })
      .catch(() => {
        this.qrScanner = undefined as any;
      });
  }

  // 🔥 HARD DOM CLEANUP (VERY IMPORTANT)
  const el = document.getElementById('qr-reader');
  if (el) {
    el.innerHTML = '';
  }
}
}
